let REACT_APP_BASE_API_URL =
  window && window._env_ ? window._env_.REACT_APP_BASE_API_URL : null;
let REACT_APP_DOCTOR_SUBDOMAIN_URL =
  window && window._env_ ? window._env_.REACT_APP_DOCTOR_SUBDOMAIN_URL : null;
let REACT_APP_ENABLE_STRIPE =
  window && window._env_ ? window._env_.REACT_APP_ENABLE_STRIPE : null;

export const Env = {
  ENABLE_STRIPE: REACT_APP_ENABLE_STRIPE || process.env.ENABLE_STRIPE,
  DOCTOR_SUBDOMAIN_URL:
    REACT_APP_DOCTOR_SUBDOMAIN_URL || process.env.DOCTOR_SUBDOMAIN_URL,
  BASE_API_URL: REACT_APP_BASE_API_URL || process.env.BASE_API_URL,
};



// WEBPACK FOOTER //
// ./src/env.js